import * as childrenRevenuePerAgeActions from './children/actions'
import * as nurseriesRevenuePerAgeActions from './nurseries/actions'
import * as revenuePerAgeStatisticsActions from './statistics/actions'

export default {
  ...childrenRevenuePerAgeActions,
  ...nurseriesRevenuePerAgeActions,
  ...revenuePerAgeStatisticsActions,
}
